import React, { useState } from "react";
import "./AiSubFlow.css";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { usePostAISettings } from "../hooks/user";
import AlertComponent from "../Components/AlertComponent";
import { addDoc, collection } from "firebase/firestore";
import { db } from "../lib/firebaseConfig";
import { TextField } from "@mui/material";
import useScrapeSite from '../hooks/useScrapeSite';
import { useAuth } from '../hooks/auth';
import { saveScrapedData } from '../hooks/useScrapeSite';


function AiSubFlow() {
  const [step, setStep] = useState(1);
  const [companyName, setCompanyName] = useState("");
  const [industry, setIndustry] = useState("");
  const [employees, setEmployees] = useState("");
  const [websiteUrl, setWebsiteUrl] = useState("");
  const [companyDescription, setCompanyDescription] = useState("");
  const [products, setProducts] = useState([
    { name: "", price: "", pageUrl: "", details: "" },
  ]);
  const [scrapedHome, setScrapedHome] = useState(null);
  const { postAISettings, isLoading, toast, setToast } = usePostAISettings();
  const { user: authUser } = useAuth();
  const { content, loading, scrapeSite } = useScrapeSite();



  
  
  const handleAddProduct = () => {
    setProducts([
      ...products,
      { name: "", price: "", pageUrl: "", details: "" },
    ]);
  };

  const handleRemoveProduct = (indexToRemove) => {
    setProducts((prevProducts) => {
      const newProducts = [...prevProducts];
      newProducts.splice(indexToRemove, 1);
      return newProducts;
    });
  };
  const handleProductChange = (index, field, value) => {
    const newProducts = [...products];
    newProducts[index][field] = value;
    setProducts(newProducts);
  };

  
  const handleScrapeAndSave = async () => {
    if (websiteUrl && authUser) {
      console.log('Starting scraping:', websiteUrl);
      
      const fetchedContent = await scrapeSite(websiteUrl); // Fetch content
      console.log('Fetched content:', fetchedContent);
      
      if (fetchedContent) {
        await saveScrapedData(authUser.uid, fetchedContent, websiteUrl);
        console.log('Data saved successfully');
        setScrapedHome(fetchedContent);
        return true;
      }
    }
    
    console.log('Scraping failed or no content obtained');
    return false;
  };
  

  const handleSubmit = async (event) => {
    event.preventDefault();
  
    if (step === 1) {
      const scrapedHome = await handleScrapeAndSave(); // Await the scraping completion
      if (scrapedHome) {
        setStep(2);
      } else {
        console.log('Scraping failed or no content obtained');
        // Handle the failure case as needed
      }
    } else if (step === 2) {
      setStep(3);
    } else if (step === 3) {
      if (products.some((product) => Object.values(product).some((value) => value === ""))) {
        // Check if any product details are empty
        console.log("Please fill in all product details before submitting the form.");
        alert("Please fill in all product details before submitting the form.");
        return;
      } for (const product of products) {
        try {
            await addDoc(collection(db, "ProductList"), product);
            console.log("Product added successfully");
        } catch (error) {
            console.error("Error adding product:", error);
        }
    }

      // Create the AI settings data object
      const aiSettingsData = {
        aiName: 'Luna', // Maybe you want to add this?
        companyName,
        industry,
        employees,
        websiteUrl,
        companyDescription,
        scrapedHome, // Include the scraped content
        isActive: true,
      };
      

      // Post AI settings using your hook
      postAISettings(aiSettingsData, authUser);
    }
  };

  const renderFormPage = () => {

    if (loading) {
      return (
        <div className="loading-container">
          <p>Scraping your website, please wait...</p>
          {/* You can replace this with a spinner component */}
        </div>
      );
    }

    switch (step) {
      case 1:
        return (
          <div className="AiSubFlow-1" style={{ marginTop: "10px" }}>
          <p style={{ marginTop: "0px", fontWeight: "800" }}>
            Step 1/3 of installation | Introduce your company{" "}
          </p>

          <TextField
            placeholder="For example: Luna Speak V1.0"
            type="text"
            label="What is the name of your company/business?"
            value={companyName}
            onChange={(event) => setCompanyName(event.target.value)}
            InputProps={{ style: { color: "white"} }}
            InputLabelProps={{ style: { color: "rgb(255 255 255 / 60%)" } }}
            sx={{ width: '100%' }}
            
            variant="outlined"
            id="outlined-basic"

            color="secondary"
          />
          <br />

          <TextField
            placeholder="For example: Saas AI Chatbot"
            type="text"
            label="What is the primary industry of your company/business?"
            value={industry}
            onChange={(event) => setIndustry(event.target.value)}
            InputProps={{ style: { color: "white" } }}
            InputLabelProps={{ style: { color: "rgb(255 255 255 / 60%)" } }}
            sx={{ width: '100%' }}

            variant="outlined"
            id="outlined-basic"
            color="secondary"


          />
          <br />

          <TextField
            placeholder="For example: 22"
            type="number"
            label="How many employees does your company/business have?"
            value={employees}
            onChange={(event) => setEmployees(event.target.value)}
            InputProps={{ style: { color: "white" } }}
            InputLabelProps={{ style: { color: "rgb(255 255 255 / 60%)" } }}
            sx={{ width: '100%' }}

                        variant="outlined"
            id="outlined-basic"
            color="secondary"

          />
          <br />

          <TextField
            placeholder="For example: www.luna-speak.com"
            type="text"
            label="What is your company website URL?"
            value={websiteUrl}
            onChange={(event) => setWebsiteUrl(event.target.value)}
            InputProps={{ style: { color: "white" } }}
            InputLabelProps={{ style: { color: "rgb(255 255 255 / 60%)" } }}
            sx={{ width: '100%' }}

            variant="outlined"
            id="outlined-basic"
            color="secondary"

          />
          <br />

          <button
            onClick={handleSubmit}
            style={{
              display: "flex",
              flexDirection: "row",
              alignContent: "center",
              alignItems: "center",
              justifyContent: "center",
              gap: "5px",
            }}
          >
            Next Page <ArrowForwardIcon />
          </button>
        </div>
      );
    case 2:
      return (
        <div className="AiSubFlow-1">
          <p style={{ marginTop: "0px", fontWeight: "800" }}>
            Step 2/3 of installation | Introduce your company{" "}
          </p>
          {/* Render second page of form here */}
          <TextField
            placeholder="Copy/paste or write your copywriting here"
            type="text"
            label="Tell us more about your company! (More details = more accurate AI)"
            value={companyDescription}
            onChange={(event) => setCompanyDescription(event.target.value)}
            InputProps={{ style: { color: "white" } }}
            InputLabelProps={{ style: { color: "rgb(255 255 255 / 60%)" } }}
            sx={{ width: '100%' }}

            variant="outlined"
            id="outlined-basic"
            color="secondary"

          />
            <br />
            <button
              onClick={handleSubmit}
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                alignItems: "center",
                justifyContent: "center",
                gap: "5px",
              }}
            >
              Next Page <ArrowForwardIcon />
            </button>
          </div>
        );
      case 3:
        return (
          <div className="AiSubFlow-1">
          <p style={{ marginTop: "0px" }}>
            Step 3 of form | Add your products
          </p>
          {/* Render third page of form here */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            <p style={{ fontWeight: "800" }}>Product 1</p>
            <TextField
              placeholder="For example: GhostWallet"
              type="text"
              label="Product name"
              value={products[0].name}
              onChange={(event) =>
                handleProductChange(0, "name", event.target.value)
              }
              InputProps={{ style: { color: "white" } }}
              InputLabelProps={{
                style: { color: "rgb(255 255 255 / 60%)" },
              }}
              sx={{ width: "100%" }}

              variant="outlined"
              id="outlined-basic"
              color="secondary"

            />
            <br />
            <TextField
              placeholder="For example: $19,99"
              type="text"
              label="Product price"
              value={products[0].price}
              onChange={(event) =>
                handleProductChange(0, "price", event.target.value)
              }
              InputProps={{ style: { color: "white" } }}
              InputLabelProps={{
                style: { color: "rgb(255 255 255 / 60%)" },
              }}
              sx={{ width: "100%" }}

              variant="outlined"
              id="outlined-basic"
              color="secondary"

            />
            <br />
            <TextField
              placeholder="www.yourshop.com/products/wallet"
              type="text"
              label="Product page URL"
              value={products[0].pageUrl}
              onChange={(event) =>
                handleProductChange(0, "pageUrl", event.target.value)
              }
              InputProps={{ style: { color: "white" } }}
              InputLabelProps={{
                style: { color: "rgb(255 255 255 / 60%)" },
              }}
              sx={{ width: "100%" }}

              variant="outlined"
              id="outlined-basic"
              color="secondary"

            />
            <br />
            <TextField
              placeholder="For example: Leather wallet with GPS inside..."
              type="text"
              label="Product details"
              value={products[0].details}
              onChange={(event) =>
                handleProductChange(0, "details", event.target.value)
              }
              InputProps={{ style: { color: "white" } }}
              InputLabelProps={{
                style: { color: "rgb(255 255 255 / 60%)" },
              }}
              sx={{ width: "100%" }}

              variant="outlined"
              id="outlined-basic"
              color="secondary"

            />
            <br />
          </div>

            {products.slice(1).map((product, index) => {
              return (
                <div key={index} style={{ marginTop: "20px" }}>
                <hr />
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <p style={{ fontWeight: "800", flexGrow: "1" }}>
                    Product {index + 2}
                  </p>
                  <button
                    onClick={() => handleRemoveProduct(index + 1)}
                    style={{
                      width: "fit-content",
                      background: "red",
                      padding: "10px",
                      height: "fit-content",
                    }}
                  >
                    <DeleteIcon style={{ fontSize: "20px" }} />
                  </button>
                </div>
                <div style={{display: 'flex', flexDirection: 'column'}}>
                <TextField
                  placeholder="For example: GhostWallet"
                  type="text"
                  label="Product name"
                  value={product.name}
                  onChange={(event) =>
                    handleProductChange(index + 1, "name", event.target.value)
                  }
                  InputProps={{ style: { color: "white" } }}
                  InputLabelProps={{
                    style: { color: "rgb(255 255 255 / 60%)" },
                  }}
                  sx={{ width: "100%" }}

                  variant="outlined"
                  id="outlined-basic"
                  color="secondary"

                />
                <br />
                <TextField
                  placeholder="For example: $19,99"
                  type="text"
                  label="Product price"
                  value={product.price}
                  onChange={(event) =>
                    handleProductChange(index + 1, "price", event.target.value)
                  }
                  InputProps={{ style: { color: "white" } }}
                  InputLabelProps={{
                    style: { color: "rgb(255 255 255 / 60%)" },
                  }}
                  sx={{ width: "100%" }}

                  variant="outlined"
                  id="outlined-basic"
                  color="secondary"

                  />
                <br />
                <TextField
                  placeholder="www.yourshop.com/products/wallet"
                  type="text"
                  label="Product page URL"
                  value={product.pageUrl}
                  onChange={(event) =>
                    handleProductChange(index + 1, "pageUrl", event.target.value)
                  }
                  InputProps={{ style: { color: "white" } }}
                  InputLabelProps={{
                    style: { color: "rgb(255 255 255 / 60%)" },
                  }}
                  sx={{ width: "100%" }}

                  variant="outlined"
                  id="outlined-basic"
                  color="secondary"

                  />
                <br />
                <TextField
                  placeholder="For example: Leather wallet with GPS inside..."
                  type="text"
                  label="Product details"
                  value={product.details}
                  onChange={(event) =>
                    handleProductChange(index + 1, "details", event.target.value)
                  }
                  InputProps={{ style: { color: "white" } }}
                  InputLabelProps={{
                    style: { color: "rgb(255 255 255 / 60%)" },
                  }}
                  sx={{ width: "100%" }}

                  variant="outlined"
                  id="outlined-basic"
                  color="secondary"

                  />
                <br />
                  </div>
              </div>
              
              );
            })}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "20px",
                marginTop: "0",
              }}
            >
              <button
                className="add-product-mobile-flow"
                onClick={handleAddProduct}
                style={{
                  background: "blue",
                  display: "flex",
                  flexDirection: "row",
                  alignContent: "center",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "4px",
                }}
              >
                Add product <AddIcon />
              </button>
              <button
                disabled={isLoading}
                className="disabled:cursor-not-allowed disabled:bg-opacity-50"
                onClick={handleSubmit}
                style={{
                  background: "#2ed573",
                  display: "flex",
                  flexDirection: "row",
                  alignContent: "center",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "0px",
                }}
              >
                Submit <ChevronRightIcon />
              </button>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="AiSubFlow-container">
      <div className="AiSubFlow">
        <div style={{display: 'flex', flexDirection: 'column', gap: '0px', justifyContent: 'center', alignItems: 'center'}}>
        <div className="emoji" style={{fontSize: '2.5rem'}}>🤖</div>
        <h1>Customize Your AI</h1>
        </div>

        <p style={{ marginBottom: "10px" }}>
          Let's get started with customizing your AI. <br /> Please answer the
          following questions to help us understand your company/business
          better.
        </p>
        <form onSubmit={handleSubmit}>{renderFormPage()}</form>
      </div>
      {/* alert message component */}
      <AlertComponent alert={toast} setOpenAlert={setToast} />
    </div>
  );
}

export default AiSubFlow;
